//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "notice",
  data(){
    return{
      sort:'DESC',
      searchData:{},
      noticeList:[],
      page:0,
      wrapperHeight:0,
      allLoaded:false
    }
  },
  methods:{
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight =
        document.documentElement.clientHeight -
        this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    onItemClick(status){
      this.page = 0;
      if(status || status == '0'){
        this.searchData.readStatus = status;
      }else{
        delete this.searchData['readStatus'];
      }
      this.getNoticeList();
    },
    loadTop(){
      this.$search('api/info-status', {sort: 'createdDate,' + this.sort, page: 0, size: 10},this.searchData).then(list => {
        this.noticeList = list;
        this.$refs.loadmore.onTopLoaded();
      }).catch((error) => {
        this.$refs.loadmore.onTopLoaded();
      });
    },
    loadBottom(){
      this.page++;
      this.$search('api/info-status', {sort: 'createdDate,' + this.sort, page: this.page, size: 10},this.searchData).then(list => {
        this.noticeList = this.noticeList.concat(list);
        this.$refs.loadmore.onBottomLoaded();
      }).catch((error) => {
        this.$refs.loadmore.onBottomLoaded();
      });
    },
    sortChange(){
      this.page = 0;
      if(this.sort === 'ASC'){
        this.sort = 'DESC'
      }else{
        this.sort = 'ASC'
      }
      this.getNoticeList();
    },
    getNoticeList(){
      this.$loadingShow();
      this.$search('api/info-status', {sort: 'createdDate,' + this.sort, page: this.page, size: 10},this.searchData).then(list => {
        this.noticeList = list;
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
  //  已经知道
    viewInfo(item){
      this.$get('api/info-status/view-info',{id:item.id}).then((data) => {
        this.$set(item,'readStatus','1');
      })
    },

  },
  mounted(){
    this.init();
    this.getNoticeList();
  }

}



// WEBPACK FOOTER //
// ./src/page/home/notice.vue